import React from 'react';
import ReactWithAddons from 'react/dist/react-with-addons'
import { Link } from 'react-router'

/** // TODO: format for better-docs/@component
 * The hyperlink wraps replaces <a> tags from the api, updating styling for
 * tasks that are past Due
 * 
 * @param {bool} context.pastDue - Whether the current time is greater than the
 *     taskActionTime from timeline component 
 * @returns {React.Element}
 *     <TaskHyperlink href={this.props.href}>
 *         {children}
 *     </TaskHyperlink>
 */
export function TaskHyperlink(props) {
    return (
        <span>
            {props.pastDue ? (
                <span>{props.children}</span>
            ) : (
                <Link
                    to={{
                        pathname: props.href,
                        hash: ""
                    }}
                >{props.children}</Link>
            )}
        </span>
    );
}

TaskHyperlink.contextTypes = {
    pastDue: React.PropTypes.bool
}

/**
 * Method for parsing out the hyperlinks from the response's html data and
 * converting thos hyperlinks to our own <TaskHyperlink ...> instances
 * @param {str} html the html from /tasks/today 
 */
const TaskDescription = ({ html, pastDue }) => {
    let content = html.replace(/\n/g, "")
        .replace(/<div>/g, "")
        .replace(/<\/div>/g, "")
        .split(/(?:<a.*?>)(.*?)(?:<\/a>)/g)//all but a tags
    let urls = html.match(/(href='.+?)(?=')/g).map(s => s.replace(/href='/g,""))
    let arr = []
    content.forEach((current, i) => {
        ((i + 1) % 2 == 0) ? (
            arr.push(React.createElement(TaskHyperlink,
                { href: urls.shift(), pastDue: pastDue, key: `task-description-${i}`},
                ReactWithAddons.addons.createFragment({
                    "title": current.replace(/<span>/g,"").replace(/<\/span>/g,"") 
                })
            ))
        ) : (
            arr.push(ReactWithAddons.addons.createFragment({
                "text": <span dangerouslySetInnerHTML={{ __html: current }} />

            }))
        )
    })
    return (
        <div>
            {arr}
        </div>
    )
}

/**
 * A task that shows when an invoice will be generated for a tenant.
 * This future task will show the upcoming invoices that will be generated that day. 
 * 
 * Responds to a task object with signature:
 *  {
 *      "task_type": "invoice_generate",
 *      "task_due_date": "00:00:00",
 *      "meta_data": {
 *          "lease_id": "13",
 *          "tenant_id": "64"
 *      }
 *  }
 * 
 * @param {*} props 
 * @returns 
 */
function InvoiceGenerate({ html }, { pastDue }) {
    return (<TaskDescription html={html} pastDue={pastDue} />);
}

InvoiceGenerate.defaultProps = {
    taskActionTime: "undefined",
    expired: "false",
    message: "Invoice generated for a tenant upcoming payment",
    donutColor: "teal",
    viewOnly: false,
    runAction: () => {
        return true
    }
};

InvoiceGenerate.propTypes = {
    tenantName: React.PropTypes.string, //This is the tenants id for linking the user profile
    tenantId: React.PropTypes.number,
    leaseId: React.PropTypes.number,
}

/**
 * A task that shows as all day when a lease had rent that's late
 * 
 * Responds to a task object with signature:
 * {
 *     "task_type": "late_rent",
 *     "task_due_date": "14:33:05",
 *     "meta_data": {
 *         "lease_id": "72",
 *         "tenant_id": "22"
 *     }
 * }
 * 
 * @param {*} props 
 * @returns 
 */
const LateRent = ({ html }, { pastDue }) => {
    return (<TaskDescription html={html} pastDue={pastDue} />);
}

LateRent.defaultProps = {
    taskActionTime: "ALLDAY",
    expired: false,
    message: "Contact tenant", // Todo: find a good message for the task action
    donutColor: "red",
    viewOnly: false,
    runAction: () => {
        return true
    }
};

LateRent.propTypes = {
    tenantName: React.PropTypes.string, //This is the tenants id for linking the user profile
    tenantId: React.PropTypes.number,
    leaseId: React.PropTypes.number,
}

/**
 * A task that notifies the user that owner payouts will run
*/
const Payouts = ({ html }, { pastDue }) => {
    return (<TaskDescription html={html} pastDue={pastDue} />);
}

Payouts.defaultProps = {
    taskActionTime: "00:00",
    expired: false,
    message: "Address owner payouts", // Todo: find a good message for the task action
    donutColor: "teal",
    viewOnly: true,
    runAction: () => {
        return true
    }
};

/**
 * A task that notifies the user that owner payouts will run
*/
const Reports = ({ html }, { pastDue }) => {
    return (<TaskDescription html={html} pastDue={pastDue} />);
}

Reports.defaultProps = {
    taskActionTime: "00:00",
    expired: false,
    viewOnly: true,
    message: "Address reports", 
    donutColor: "teal",
    runAction: () => {
        return true
    }
};

/**
 * A task that notifies the user that owner payouts will run
 * {
 *     'task_type' => "vendor_bill_due",
 *     'task_due_date'         => $bill->due_at,
 *     'meta_data'             => [
 *         'vendor_bill_id' => $bill->vendor_bill_id,
 *         'vendor_id'      => $bill->created_by
 *     ],
 * }
*/
const Payables = ({ html }, { pastDue }) => {
    return (<TaskDescription html={html} pastDue={pastDue} />);
}

Payables.defaultProps = {
    taskActionTime: "00:00",
    expired: false,
    message: "Address vendor bill", // Todo: find a good message for the task action
    donutColor: "orange",
    viewOnly: true,
    allDay: true
};

Object.map = (obj, fn) =>
  Object.fromEntries(
    Object.entries(obj).map(
      ([k, v], i) => [k, fn(v, k, i)]
    )
  )

let TaskPrimitives = {}
export default Object.assign(TaskPrimitives,
    Object.map({
        InvoiceGenerate: InvoiceGenerate,
        LateRent: LateRent,
        Payouts: Payouts,
        Reports: Reports,
        Payables: Payables
    }, val => Object.assign( val, {
            contextTypes: { pastDue: React.PropTypes.bool },
        })
    )
)


// WEBPACK FOOTER //
// app/components/UpcomingTasks/TaskPrimitives.jsx